// Map raw SSE step keys → visual step index
const DISPLAY_STEP_INDICES = Object.freeze({
  analyzing_documents: 0,
  triaging_documents: 0,
  document_triage: 0,
  uploading_documents: 1,
  extracting: 2,
  switching_provider: 2,
});

// Ordered visual steps shown in the progress UI.
export const DISPLAY_STEPS = Object.freeze([
  { displayKey: 'analyzing' },
  { displayKey: 'uploading' },
  { displayKey: 'extracting' },
]);

export const getDisplayStepIndex = (sseStepKey) => {
  if (sseStepKey == null) return 0;
  const idx = DISPLAY_STEP_INDICES[sseStepKey];
  return idx != null ? idx : 0;
};

export const hasExtractionEnded = (status) => ['COMPLETED', 'FAILED', 'CANCELLED'].includes(status);
